var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('MainHead'),[(_vm.getItems.length === 0)?_c('MainSkeleton'):_c('MainSection',{attrs:{"items":_vm.getItems}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }